import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import sanityClient from "../../sanityClient"; // Ensure this import is correct
import BlockContent from "@sanity/block-content-to-react"; // Import BlockContent
import styled from "styled-components";
import CTASection from "../../components/CTASection"; // Adjust the path as necessary

const RepairDetail = () => {
  const { id } = useParams();
  const [program, setProgram] = useState(null);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "repairProgram" && _id == $id] {
          title,
          description,
          programDetails,
          servicesOffered,
          eligibility,
          "imageUrl": image.asset->url
        }`,
        { id }
      )
      .then((data) => setProgram(data[0]))
      .catch(console.error);
  }, [id]);

  if (!program) return <div>Loading...</div>;

  return (
    <RepairDetailContainer>
      {program.imageUrl && (
        <RepairDetailImage src={program.imageUrl} alt={program.title} />
      )}
      <RepairDetailTitle>{program.title}</RepairDetailTitle>
      <RepairDetailBody>
        <Section>
          <h3>Program Description</h3>
          <p>{program.description}</p>
        </Section>
        <Section>
          <h3>Program Details</h3>
          <BlockContent blocks={program.programDetails} />
        </Section>
        <Section>
          <h3>Services Offered</h3>
          <BlockContent blocks={program.servicesOffered} />
        </Section>
        <Section>
          <h3>Eligibility</h3>
          <BlockContent blocks={program.eligibility} />
        </Section>
      </RepairDetailBody>
      <CTASection
        title="Interested in Home Repair?"
        description="Apply for our home repair program today and get the assistance you need to improve your living conditions."
        buttonText="Apply Now"
        buttonLink="https://habitatbflo.my.site.com/chrapp/s/"
      />
    </RepairDetailContainer>
  );
};

const RepairDetailContainer = styled.div`
  max-width: 800px;
  margin: 40px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 15px;
    margin: 30px auto;
  }

  @media (max-width: 480px) {
    padding: 10px;
    margin: 20px auto;
  }
`;

const RepairDetailImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 20px;
`;

const RepairDetailTitle = styled.h1`
  font-size: 2.5em;
  margin-bottom: 20px;
  color: var(--hhb-primary);
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2em;
    margin-bottom: 15px;
  }

  @media (max-width: 480px) {
    font-size: 1.8em;
    margin-bottom: 10px;
  }
`;

const RepairDetailBody = styled.div`
  font-size: 1.2em;
  line-height: 1.8;
  color: #333;
  margin-bottom: 20px;

  p {
    margin-bottom: 20px;
  }

  blockquote {
    font-style: italic;
    margin: 20px 0;
    padding: 10px 20px;
    background-color: #e9e9e9;
    border-left: 5px solid var(--hhb-primary);
  }

  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    font-size: 1.1em;

    blockquote {
      padding: 8px 15px;
      margin: 15px 0;
    }
  }

  @media (max-width: 480px) {
    font-size: 1em;

    blockquote {
      padding: 6px 10px;
      margin: 10px 0;
    }
  }
`;

const Section = styled.div`
  margin-bottom: 40px;

  @media (max-width: 768px) {
    margin-bottom: 30px;
  }

  @media (max-width: 480px) {
    margin-bottom: 20px;
  }
`;

export default RepairDetail;
